import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const state = {
  userInfo: null, // 用户信息
  baseLink: '', // 环境域名
  headerHeight: null, // 头部的高度
}
const getters = {
  //实时监听state值的变化(最新状态)
  userInfo: state => state.userInfo,
  baseLink: state => state.baseLink,
  headerHeight: state => state.headerHeight,
}
const mutations = {
  // 同步改变state中的值
  setUserInfo(state, payload) {
    state.userInfo = payload
  },
  setBaseUrl(state, payload) {
    state.baseLink = payload
  },
  setHeaderHeight(state, payload) {
    state.headerHeight = payload
  },
}
const actions = {
  // 异步改变state中的值
  setUserInfoAnsy(context, payload) {
    context.commit('setUserInfo', payload)
  },
  setBaseUrlAnsy(context, payload) {
    context.commit('setBaseUrl', payload)
  },
  setHeaderHeightAnsy(context, payload) {
    context.commit('setHeaderHeight', payload)
  },
}
const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
})

export default store
